<template>
  <div class="column has-text-centered">
    <b-icon
      icon="lightbulb"
      :style="{ color: researchIsActive ? 'black' : '#d1d1d1' }"
    ></b-icon>
    <br />

    <span :style="{ color: researchIsActive ? 'black' : '#d1d1d1' }">
      Pesquisa
    </span>
  </div>
</template>

<script>
export default {
  props: ["researchIsActive"]
};
</script>

<style scoped>
div {
  font-size: 1rem;
}
</style>
